import { Directive, Input, OnInit } from '@angular/core';
import { Block } from '@core/models/block/block.model';
import { FormService } from '@modules/creator/components/special-block/forms/services/form.service';
import { hasRequiredField } from '@shared/helpers/form-helpers';
import { Observable, of } from 'rxjs';

@Directive()
export class FormFieldBase implements OnInit {
  @Input() item: Block;

  formGroup = this.fs.formGroup;

  constructor(protected fs: FormService) {
  }

  get inputType() {
    return this.item.settings.inputType || 'text';
  }

  get formName() {
    return this.item.settings.formControlName || '';
  }

  get invalid() {
    return this.formGroup.get(this.formName)?.invalid || false;
  }

  get touched() {
    return this.formGroup.get(this.formName)?.touched || false;
  }

  get required() {
    if (this.item.settings.inputSettings) {
      return this.item.settings.inputSettings?.required;
    }
    return hasRequiredField(this.formGroup.get(this.formName));
  }

  get maxLength() {
    const {useMaxLength = false, maxLength = null} = this.item.settings.inputSettings || {};
    if (useMaxLength && maxLength) {
      return maxLength;
    }
    return false;
  }

  dataChanged(event: any) {
    this.fs.changed.next({event, formControlName: this.formName});
  }

  onKey(event: KeyboardEvent): void {
    const el = event.target as HTMLElement | null;

    if (el?.closest('mat-checkbox,[role="checkbox"]')) {
      return;
    }

    this.fs.keyboardEvent.next(event);
  }

  ngOnInit(): void {
    const {formControlName, inputType, inputSettings} = this.item.settings;
    this.fs.addTextControlValidatable(formControlName, inputType, inputSettings);
  }

  getErrorMessage$(): Observable<string> {
    const errors = this.formGroup.get(this.formName);
    if (errors.hasError('required')) {
      return of('forms.required');
    } else if (errors.hasError('email')) {
      return of('forms.email');
    } else if (errors.hasError('serverError')) {
      const message = errors.getError('serverError')?.message;
      return of(message);
    } else if (errors.hasError('customError')) {
      const message = errors.getError('customError')?.message;
      return of(message);
    }
  }
}
